import React from 'react'
import {Input} from 'semantic-ui-react'
import '../LabelButtonsInput/LabelButtonsInput.css'
import {Form} from "semantic-ui-react";

const Appx = (props) => (

<Form.TextArea
  required={props.required} label={props.tagText}
  placeholder={props.placeholder}
  onChange={props.onChange}
  value={props.value}
  disabled={props.disable}
  name={props.name}
  type={props.type} maxLength={props.maxLength ? props.maxLength : 3000 }/>
);

export default Appx;
